import { appColors } from '@backrs_ui/common-ui';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type ResultsPillProps = Readonly<{
  title: string;
}>;

export const ResultsPill = ({ title }: ResultsPillProps) => {
  return (
    <Box sx={pillStyle}>
      <Typography variant="body1" sx={pillTitleStyle}>
        {title}
      </Typography>
    </Box>
  );
};

const pillStyle: SxProps<Theme> = {
  paddingY: 1,
  borderRadius: '8px',
  paddingX: 2,
  color: appColors.color.blue1,
  backgroundColor: `${appColors.color.blue9}80`,
  width: 'fit-content',
};

const pillTitleStyle: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 'bold',
};
